import { apiClient } from "../core/apiClient";

export interface ICategory {
  id: number;
  nombre: string;
}

class CategoryService {
  /**
   * Obtiene todas las categorías desde el backend
   */
  static async getAllCategories(): Promise<ICategory[]> {
    const response = await apiClient.get<ICategory[]>("/api/v1/categories");
    return response.data;
  }

  /**
   * Crea una nueva categoría
   */
  static async createCategory(nombre: string): Promise<ICategory> {
    const response = await apiClient.post<ICategory>("/api/v1/categories", { nombre });
    return response.data;
  }

  /**
   * Encuentra una categoría por nombre, o la crea si no existe
   */
  static async findOrCreateByName(nombre: string): Promise<ICategory> {
    const categories = await this.getAllCategories();
    const existing = categories.find(
      (c) => c.nombre.toLowerCase() === nombre.toLowerCase()
    );
    if (existing) {
      return existing;
    }
    // Si no existe, la creamos
    return await this.createCategory(nombre);
  }
}

export default CategoryService; 
